import './AdminSearchFilters.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Col, DatePicker, Input, Radio, Row, Select, Modal, Tooltip } from 'antd'
import { UsersService } from '../../../../services'

const { Option } = Select

const AdminSearchFilters = ({
  currentUser,
  selectedItem,
  isLoadingReportZip,
  defaultValues,
  onChangeStatusHandler,
  onChangeDateHandler,
  onChangeDateFromHandler,
  onChangeDateToHandler,
  onChangeHasReportHandler,
  onChangeSearchHandler,
  onChangeModeHandler,
  onChangeSearchOutcomeHandler,
  onChangeSearchTypeIsRutHandler,
  onChangeUserHandler,
  onChangeTypeHandler,
  onClickRestoreFiltersHandler,
  onClickExportHandler,
  onClickPdfHandler,
  onSubmit,
  modulo
}) => {
  const [users, setUsers] = useState([])
  const [modules, setModules] = useState([])
  const [searchTypeIsRut, setSearchTypeIsRut] = useState(true)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { t } = useTranslation()

  const isAuthSearch = modulo === 'auth-search' && currentUser.cliente.modules.includes('AUTH-SEARCH')

  useEffect(() => {
    UsersService.read()
      .then(response => {
        const u = response.data.records.sort((a, b) => {
          const left = (a.login || '').toLowerCase()
          const right = (b.login || '').toLowerCase()
          return left.localeCompare(right)
        })
        setUsers(u)
      })
      .catch(err => console.log(err))
    if(currentUser.modules != null) {
      for(let i=0;i<currentUser.modules.length;i++) {
        let module = currentUser.modules[i]
        if(module === 'PEP' || module === 'PEPH' || module === 'PEPC' || module === 'PERSON' || module === 'PJUD' || module === 'VIP' || module === 'PFA' || module === 'NEG') {
          if(currentUser.cliente.modules.includes(module) ||
            (module === 'PJUD' && (currentUser.cliente.modules.includes('PJUD-PENAL') || currentUser.cliente.modules.includes('PJUD-CIVIL')
                                  || currentUser.cliente.modules.includes('PJUD-COB') || currentUser.cliente.modules.includes('PJUD-LAB')
                                  || currentUser.cliente.modules.includes('PJUD-APE') || currentUser.cliente.modules.includes('PJUD-SUP')
                                  ))
            ) {
            modules.push(module)
          }
        }
      }
    }
  }, [])

  const handleSearchTypeIsRutChange = (e) => {
    const value = e.target.value

    setSearchTypeIsRut(value)

    onChangeSearchTypeIsRutHandler(value)
  }

  const handleDateChange = (value) => {
    if (value === 'RANGE') {
      setIsModalVisible(true)
    } else {
      setIsModalVisible(false)
    }
    onChangeDateHandler(value)
  }

  const titleModule = (module) => {
    if(module === 'PEPH') return t('messages.aml.historicalPEPS')
    if(module === 'PERSON') return t('messages.aml.modulesNames.peopleInterest')
    if(module === 'PEPC') return t('messages.aml.candidates')
    if(module === 'PFA') return 'Dow Jones R&C'
    if(module === 'NEG') return t('messages.aml.modulesNames.ownLists')
    if(module === 'PJUD') return t('messages.aml.powerOfAttorney')
    return module
  }

  return (
    <div className='admin-search-filters'>
      <Row>
        <Col xs={isAuthSearch ? 10 : 6}>
          <div className="rut-name module">
            <Radio.Group value={ defaultValues.searchFiltersTypeIsRut } onChange={ handleSearchTypeIsRutChange }>
              <Radio value={ true }>{ t('messages.aml.rutNumber') }</Radio>
              <Radio value={ false }>{ t('messages.aml.name') }</Radio>
            </Radio.Group>
            <div className="module-inner">
              <Input placeholder={ searchTypeIsRut ? t('messages.aml.enterRutNumber') : t('messages.aml.enterName') } onChange={ onChangeSearchHandler } onSearch={ (e) => e.preventDefault() } value={ defaultValues.search } />
            </div>
          </div>
        </Col>
        <Col xs={isAuthSearch ? 6 : 4}>
          <div className="user module">
            { t('messages.aml.username') } :
            <div className="module-inner">
              <Select value={ defaultValues.searchFiltersUser } onChange={ onChangeUserHandler } style={{ width: '100%' }}>
                <Option value="">[ { t('messages.aml.allTheUsers') } ]</Option>
                { users.map(user => <Option value={ user.id }>{ user.login }</Option>) }
              </Select>
            </div>
          </div>
        </Col>
        { !isAuthSearch &&
          <Col xs={6}>
            <div className="certificate module">
              Con certificado :
              <div className="module-inner">
                <Radio.Group key="3" value={defaultValues.searchFiltersHasReport} onChange={onChangeHasReportHandler}>
                  <Radio value="ALL">Todos</Radio>
                  <Radio value="S">Si</Radio>
                  <Radio value="N">No</Radio>
                </Radio.Group>
              </div>
            </div>
          </Col>
        }

        { !isAuthSearch &&
          <Col xs={8}>
            <div className="outcome module">
              Desenlace de las búsquedas :
              <div className="module-inner">
                <Radio.Group value={ defaultValues.searchFiltersOutcome } onChange={ onChangeSearchOutcomeHandler }>
                  <Radio value="S">{ t('messages.aml.withResults') }</Radio>
                  <Radio value="N">{ t('messages.aml.withoutResults') }</Radio>
                  <Radio value="ALL">{ t('messages.aml.both')}</Radio>
                </Radio.Group>
              </div>
            </div>
          </Col>
        }
      </Row>
      <Row>
        { !isAuthSearch &&
          <Col xs={6}>
            <div className="type module">
              { t('messages.aml.module') } :
              <div className="module-inner">
                <Select value={ defaultValues.searchFiltersType } onChange={ onChangeTypeHandler } style={{ width: '100%' }}>
                  <Option value={null}>[ { t('messages.aml.allModules') } ]</Option>
                  { modules.map(module =>
                    <Option value={module}>{ titleModule(module) }</Option>
                  )}
                </Select>
              </div>
            </div>
          </Col>
        }
        <Col xs={isAuthSearch ? 10 : 4}>
          <div className="module">
            { t('messages.aml.dates') } :
            <div className="module-inner">
              <Select value={ defaultValues.searchFiltersDate } onChange={ handleDateChange } style={{ width: '100%' }}>
                <Option value="ALL">[ { t('messages.aml.allTheDates') } ]</Option>
                <Option value="TODAY">{ t('messages.aml.today') }</Option>
                <Option value="WEEK">{ t('messages.aml.lastWeek') }</Option>
                <Option value="MONTH">{ t('messages.aml.lastMonth') }</Option>
                <Option value="3MONTH">{ t('messages.aml.last3Months') }</Option>
                <Option value="RANGE">{ t('messages.aml.customRange') }</Option>
              </Select>
            </div>
          </div>
        </Col>
        { isAuthSearch ?
          <Col xs={6}>
            <div className="module">
              {t('messages.aml.formTable.column.status')} :
              <div className="module-inner">
                <Select value={ defaultValues.searchFiltersStatus } onChange={ onChangeStatusHandler } style={{ width: '100%' }}>
                  <Option value={null}>[ { t('messages.aml.all') } ]</Option>
                  <Option value="APROBADO">{ t('messages.aml.searches.status.APROBADO') }</Option>
                  <Option value="RECHAZADO">{ t('messages.aml.searches.status.RECHAZADO') }</Option>
                  <Option value="PENDIENTE">{ t('messages.aml.searches.status.PENDIENTE') }</Option>
                </Select>
              </div>
            </div>
          </Col>
          :
          <Col xs={6}>
            <div className="mode module">
              Modo :
              <div className="module-inner">
                <Radio.Group key="2" value={ defaultValues.searchFiltersMode } onChange={ onChangeModeHandler }>
                  <Radio value="ALL">{ t('messages.aml.all') }</Radio>
                  <Radio value="ONLINE">{ t('messages.aml.online') }</Radio>
                  <Radio value="BATCH">Batch</Radio>
                  <Radio value="SERVICIO">{ t('messages.aml.service', 'Servicio') }</Radio>
                </Radio.Group>
              </div>
            </div>
          </Col>
        }
        <Col xs={8}>
          <div className="submit module">
            <div className="module-inner">
              <Button type="primary" onClick={ onSubmit } icon="check">{ t('messages.aml.apply') }</Button>&nbsp;
              <Button type="primary" onClick={ onClickExportHandler } icon="file-excel">{ t('messages.aml.export') }</Button>&nbsp;
              <Button onClick={ onClickRestoreFiltersHandler } ghost icon="stop">{ t('messages.aml.clear') }</Button>&nbsp;
              <Tooltip title={ t('messages.aml.downloadCertificatePdf') }>
                <Button type="primary" onClick={ onClickPdfHandler } icon="file-pdf" loading={isLoadingReportZip} disabled={isLoadingReportZip || !(selectedItem && selectedItem.length > 0)}/>
              </Tooltip>

            </div>
          </div>
        </Col>
      </Row>

      <Modal visible={isModalVisible}
        onCancel={ () => setIsModalVisible(false) }
        footer={ [
          <Button onClick={ () => setIsModalVisible(false) }>{ t('messages.aml.btnClose') }</Button>
        ] }
        >
        <div className="date-pickers module">
          <Row>
            <Col xs={ 12 }>
              { t('messages.aml.fromDate') } :
              <div className="module-inner">
                <DatePicker format="DD/MM/YYYY" defaultValue={ defaultValues.searchFiltersDateFrom } onChange={ onChangeDateFromHandler } placeholder={ t('messages.aml.fromDatePlaceholder') } />
              </div>
            </Col>
            <Col xs={ 12 }>
              { t('messages.aml.toDate') } :
              <div className="module-inner">
                <DatePicker format="DD/MM/YYYY" defaultValue={ defaultValues.searchFiltersDateTo } onChange={ onChangeDateToHandler } placeholder={ t('messages.aml.toDatePlaceholder') } />
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  )
}

export default AdminSearchFilters;
